<template>
  <VModal :show="show" :title="$t('survey')" type="small">

    <VAlert type="error" v-if="error">لطفا تمام فیلد ها را پر کنید</VAlert>

    <ul class="my-2" v-if="questions.length > 0">
      <li
          v-for="question in questions"
          :key="question.id"
          class="mt-4 flex justify-between">

        <span>{{ question.question }}</span>

        <StarRating v-model="question.score" class="ltr"/>
      </li>
    </ul>

    <LoadingSpinner class="w-10 mx-auto" v-else/>

    <VInput type="text" class="mt-4 w-full" :placeholder="$t('survey_description_placeholder')" v-model="description"/>

    <VButton class="w-full mt-4" @click="submit">ثبت</VButton>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VButton from "@/components/General/VButton";
import {createSurvey, getSurveyQuestions} from "@/API/API";
import StarRating from "@/components/General/StarRating.vue";
import VAlert from "@/components/General/VAlert.vue";
import VInput from "@/components/General/VInput.vue";
import LoadingSpinner from "@/components/General/LoadingSpinner.vue";

export default {
  name: "SurveyModal",
  components: {LoadingSpinner, VInput, VAlert, StarRating, VButton, VModal},
  props: ['show', 'title'],
  data() {
    return {
      questions: [],
      error: false,
      description: ''
    }
  },
  methods: {
    async getQuestions() {
      this.questions = (await getSurveyQuestions()).data
    },
    submit() {
      if (!this.validate()) {
        this.error = true
        return;
      }

      this.error = false
      let survey = {
        questions: this.questions,
        description: this.description
      }

      createSurvey(survey)
          .then(resp => {
            this.$emit('created')
            this.$infoModal.value = resp.data.message
          })

    },
    validate() {
      return this.questions.every(question => question.score)
    }
  },
  watch: {
    show() {
      if (this.show)
        this.getQuestions()
      else {
        this.questions = []
        this.description = ''
      }
    }
  }
}
</script>

<style scoped>

</style>